import httpClient from "Api/httpClient";

const END_POINT = "/work_orders";

const getWorkOrders = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getWorkOrder = (id) => {
    if (!id) return;
    const SINGLE_END_POINT = END_POINT + "/" + id;
    return httpClient.get(SINGLE_END_POINT);
};

const printWorkOrder = (id) => {
    if (!id) return;
    const SINGLE_END_POINT = END_POINT + "/" + id + "?print=1";
    return httpClient.get(SINGLE_END_POINT);
};

const createWorkOrders = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateWorkOrders = (payload, id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteWorkOrders = (id) => {
    const DELETE_END_POINT = END_POINT + "/" + id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getWorkOrders, getWorkOrder, printWorkOrder, createWorkOrders, updateWorkOrders, deleteWorkOrders };
